/* eslint-disable max-lines */

import plural from 'plurals-cldr'
import {LangUtil, PluralNoun} from './lang-util'
import {billEn} from './parts/bill'
import {boardEn} from './parts/board'
import {boardAppearanceEn} from './parts/board-appearance'
import {calendarEn} from './parts/calendar'
import {chatEn} from './parts/chat'
import {colorPickerEn} from './parts/color-picker'
import {columnOrderEn} from './parts/column-order'
import {commonEn} from './parts/common'
import {companiesEn} from './parts/companies'
import {companyDashboardEn} from './parts/company-dashboard'
import {componentEn} from './parts/component'
import {crmEn} from './parts/crm'
import {dependencyEn} from './parts/dependency'
import {emojiReactionsEn} from './parts/emoji-reactions'
import {extensionsEn} from './parts/extensions'
import {feedbackEn} from './parts/feedback'
import {fileViewerEn} from './parts/file-viewer'
import {globalSearchEn} from './parts/global-search'
import {googleCalendarEn} from './parts/google-calendar'
import {groupChatEditorEn} from './parts/group-chat'
import {helpEn} from './parts/help'
import {importFromFileEn} from './parts/import-from-file'
import {importFromTrelloEn} from './parts/importFromTrello'
import {invitePopupEn} from './parts/invite-popup'
import {menuEn} from './parts/menu'
import {messageForwardingEn} from './parts/message-forwarding'
import {mirroredTasksEn} from './parts/mirrored-tasks'
import {movementTemplatesEn} from './parts/movement-templates'
import {multiActionsWithTasksEn} from './parts/multi-actions-with-tasks'
import {myStickersEn} from './parts/my-stickers'
import {myTasksEn} from './parts/my-tasks'
import {noLicenseEn} from './parts/no-license'
import {partnerEn} from './parts/partner'
import {permissionEn} from './parts/permission'
import {profilePageEn} from './parts/profile-page'
import {projEn} from './parts/proj'
import {regEn} from './parts/regEn'
import {repeatEn} from './parts/repeat'
import {reportEn} from './parts/report'
import {screencastEn} from './parts/screencast'
import {serverEn} from './parts/server'
import {shareEn} from './parts/share'
import {statsReportsTableEn} from './parts/stats-reports-table'
import {statsTimelineEn} from './parts/stats-timeline'
import {stickerItemEn} from './parts/sticker-item'
import {stickerNamesEn} from './parts/sticker-names'
import {stickerPanelEn} from './parts/sticker-panel'
import {subtaskEn} from './parts/subtask'
import {taskPageEn} from './parts/task-page'
import {taskTemplatesEn} from './parts/task-templates'
import {timelineEn} from './parts/timeline'
import {userEventsEn} from './parts/user-events'
import {usersEn} from './parts/users'
import {usersTableEn} from './parts/usersTable'
import {votingEn} from './parts/voting'
import {workflowEn} from './parts/workflow'

export const langEn = {
  lang: 'en',
  imgCode: 'en',
  langName: 'English',

  component: componentEn,
  subtask: subtaskEn,
  report: reportEn,
  server: serverEn,
  repeat: repeatEn,
  stickerNames: stickerNamesEn,
  common: commonEn,
  companies: companiesEn,
  timeline: timelineEn,
  dependency: dependencyEn,
  permission: permissionEn,
  reg: regEn,
  menu: menuEn,
  googleCalendar: googleCalendarEn,
  stickerPanel: stickerPanelEn,
  profilePage: profilePageEn,
  chat: chatEn,
  feedback: feedbackEn,
  taskPage: taskPageEn,
  myTasks: myTasksEn,
  users: usersEn,
  proj: projEn,
  help: helpEn,
  partner: partnerEn,
  bill: billEn,
  userEvents: userEventsEn,
  extensions: extensionsEn,
  share: shareEn,
  stickerItem: stickerItemEn,
  statsTimeline: statsTimelineEn,
  statsReportsTable: statsReportsTableEn,
  colorPicker: colorPickerEn,
  calendar: calendarEn,
  importFromTrello: importFromTrelloEn,
  companyDashboard: companyDashboardEn,
  importFromFile: importFromFileEn,
  emojiReactions: emojiReactionsEn,
  workflow: workflowEn,
  myStickers: myStickersEn,
  groupChatEditor: groupChatEditorEn,
  messageForwarding: messageForwardingEn,
  fileViewer: fileViewerEn,
  multiActionsWithTasks: multiActionsWithTasksEn,
  board: boardEn,
  mirroredTasks: mirroredTasksEn,
  columnOrder: columnOrderEn,
  usersTable: usersTableEn,
  screencast: screencastEn,
  movementTemplates: movementTemplatesEn,
  taskTemplates: taskTemplatesEn,
  invitePopup: invitePopupEn,
  boardAppearance: boardAppearanceEn,
  noLicense: noLicenseEn,
  globalSearch: globalSearchEn,
  voting: votingEn,
  crm: crmEn,

  monthsFirstForm: [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
  ],

  months: [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
  ],

  monthsFull: [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ],

  mainTitle: 'YouGile',
  whatsNew: 'What’s new:',
  coworkers: 'Coworkers',
  admins: 'Admins',
  usersStr: 'Users',
  signup: 'Sign up',

  of: 'out of',
  from: 'from',
  to: 'to',
  pcs: 'pcs',

  loadBg: 'Load a new background',
  account: 'Profile',
  editAccount: 'Edit profile',
  logout: 'Log Out',
  name: 'Name',
  namePlaceholder: 'Your name',
  namePl: 'Enter your name',
  phone: 'Phone',
  phonePl: 'Enter your phone',
  nameEmpty: 'Name must not be empty',
  phoneEmpty: 'Please, enter your phone',
  phoneIncorrect: 'Please, check the format of the phone number',
  sHSuccess: 'Success, we’ll contact you shortly',
  companyEmpty: 'Please, specify your company',
  nameShort: 'Name is too short',
  email: 'E-mail',
  emailPl: 'Enter your e-mail',
  yourEmail: 'Your e-mail:',
  emailPlaceholder: 'Type an e-mail…',
  emailIncorrect: 'E-mail is incorrect',
  emailIncorrect2: 'Check the correctness of the e-mail',
  emailExists: 'User with this e-mail already exists.',
  incorrectEmailPass: 'Incorrect e-mail or password',
  forgotAcc: 'Forgotten your account?',
  resetPass: 'Reset your password:',
  resetPass2: 'Reset password',
  resetPassSent: 'We’ve sent you an e-mail with a password reset link',
  go: 'Go!',
  password: 'Password',
  passwordPl: 'Choose your password',
  passwordShort: 'Password is too short',
  noPassword: 'Password is not specified',
  passwordPlaceholder: 'Password',
  startTrial: 'Start trial',
  signIn: 'Sign in!',
  signIn2: 'sign in',
  signIn3: 'Sign in',
  serverError: 'Error from the server',
  optional: '(optional)',
  required: '(required)',
  startUsing: 'Start using!',
  addAsNewLabel: (value: string) => `Add "${value}" as new`,
  registerLastStep: 'Last step, fill out your profile:',
  haveAcc: 'Have an account already?',
  unexpectedErr: 'Unexpected error, please try later',
  resetPassEmailInfo:
    'You’ve been sent an e-mail, follow the link in the ' +
    'e-mail to reset your password',
  registration: 'Registration',
  doRegister: 'Register!',
  uploadPhoto: 'Upload your photo',
  uploadPhoto2: 'Upload a photo…',
  uploadAnotherPhoto: 'Upload a different photo…',
  save: 'Save',
  ok: 'Ok',
  create: 'Create',
  createTask: 'Create a task',
  cancel: 'Cancel',
  apply: 'Apply',
  close: 'Close',
  finish: 'Finish',
  yes: 'Yes',
  no: 'No',
  add: 'Add',
  and: 'and',
  unpin: 'unpin',
  historyChanges: 'History of changes',
  stopStopwatch: 'Stop the stopwatch',
  stopTimer: 'Stop the timer',
  startStopwatch: 'Start the stopwatch',
  startTimer: 'Start the timer',
  startedBy: 'Started by',
  stoppedBy: 'Stopped by',
  runTime: 'Run time:',
  stoppedTime: 'Stopped time:',
  set: 'set',
  weeks: 'Weeks',
  days: 'Days',
  hours: 'Hours',
  minutes: 'Minutes',
  w: 'w',
  d: 'd',
  h: 'h',
  m: 'min',
  s: 'sec',
  mShort: 'm',
  timeWeek: 'Week',
  time2Week: 'Two weeks',
  timeMonth: 'Month',
  timeCustom: 'Custom',
  change: 'Change',
  start: 'Start',
  totalStopsTime: 'Total stops time:',
  goBack: 'go back…',
  back: 'Back',
  timeInColumnsTitle: (boardTitle: string, projectTitle: string) =>
    `Board “${boardTitle}” of the project “${projectTitle}”`,
  averageTimeInColumns: 'Average time in columns',
  averageTimeInColumnsDescription:
    'We calculated how much time the tasks spent in each column,' +
    'averaged it and showed it on the graph. \n \n ' +
    'If the column is red and tall, you should pay attention to it,' +
    'this is where tasks spend the most time',
  hide: 'Hide',
  show: 'Show',
  showAll: 'Show all',
  all: 'All',
  allColumns: 'All columns',
  allProjects: 'All projects',
  chooseColor: 'Choose a color:',
  stickers: 'stickers',
  stickers2: 'Stickers',
  user: 'User',
  openTask: 'Open task',
  deadline: 'Deadline',
  timer: 'Timer',
  timerDescription: 'Set the time after which the task should be completed.',
  stopwatch: 'Stopwatch',
  dragStickerToTask: 'Drag this sticker from the sticker panel to the task.',
  stopwatchDescription:
    'The stopwatch will show how long the task is in the open state.',
  timetracking: 'Time tracking',
  nMessages: 'messages',
  projects: 'Projects',
  projectsMenuTitle: 'Projects and Permissions',
  project: 'Project',
  accountAndSettings: 'Account / Settings',
  companyProjects: 'Projects',
  addProject: 'Add project',
  addProjectWithTasks: 'Add project with tasks',
  addBoard: 'Add board',
  addColumn: 'Add column',
  addTask: 'Add task',
  extensionsInColumnLabel: 'Extensions in the column:',
  confirmDeleteCompany: 'Are you sure you want to delete this company?',
  confirmDeleteCompany2:
    'You will lose all the data from this company ' +
    '(files, messages, tasks). Proceed anyway?',
  confirmDeleteCompany3: 'Leave the company?',
  confirmDeleteCompany3Hint:
    'You will be removed from the company and will not be able to return to it without a new invitation from the administrator',
  disallowDeleteOnlyCompany:
    'This is your only company, ' + 'please add another to delete this one.',
  disallowRenameCompanyNotAdmin: 'You’re not an admin in this company.',
  notAdmin: 'You’re not an admin in this company.',
  companyDeleted: 'Company deleted successfully',
  confirmDeleteProject: 'Delete project?',
  confirmDeleteProjectHint:
    'When you delete a project, all tasks in it will also be deleted',
  projectPlaceholder: 'Type a project name…',
  project404: 'Project not found',
  allUsers: 'All users',
  invite: 'Invite',
  inviteAnother: 'Invite another user',
  inviteAgain: 'Invite another user',
  userInviteOk: 'User was invited successfully',
  usersInviteOk: (n: number) => `Successfully invited ${n} users`,
  failedToSendInvitation:
    'Failed to send invitation, ' + 'check if the specified e-mail is correct',
  userInviteAlreadyInvited: 'User was already invited',
  inviteByEmailAlt: 'Send emal invitation',
  emailToInvite: 'E-mail of the user you want to invite:',
  showMore: 'Show more »',
  showMore2: 'Show more',
  showMore31: 'Show',
  showMore32: 'more',
  showMoreTasks: (count: number) =>
    `Show ${count} more ${langEn.taskNoun[plural('en', count)]}`,
  showLess: '« Show less',
  chats: 'Chats',
  chats2: 'Chats',
  saveChanges: 'Save changes',
  description: 'Description',
  addDescription: 'Add a description',
  editDescription: 'Edit the description',
  editTaskNamePlaceholder: 'Task name',
  saveDescription: 'Save description',
  descriptionPlaceholder: 'Type a description here…',
  labelPlaceholder: 'Enter a name for the label…',
  typing: 'typing…',
  moreTyping: (count: number) => `and ${count} more typing…`,
  newMsg: 'New message',
  writeNewMessage: 'Write message',
  justFeedback: 'Feedback',
  dropFileToChat: 'Drop file here to add it into chat',
  addPeopleToProject: 'Add people to project',
  orInviteByEmail: 'Or invite a new user to this project by e-mail:',
  warnSelfDeleteFromProject:
    'If you’ll delete yourself from this project ' +
    'you’ll be unable to revert it by yourself.\nProceed anyway?',
  warnLastUserInProject:
    'Cannot remove the last user in this project. ' +
    'Maybe you wanted to delete this project?',
  chooseStickerIcon: 'Choose an icon:',
  confirmStickerStateDelete: 'Delete this state?',
  confirmStickerDelete: 'Are you sure you want to delete this sticker?',
  stickerStatePlaceholder: 'Type a new state…',
  addState: 'Add a state',
  userOnline: 'The user is online',
  userOffline: 'The user is offline',
  userOfflineSeenAt: 'The user is offline, last seen at ',
  userDnd:
    'The user is in "Do not disturb mode" and will not receive' +
    ' notifications until ',
  version: 'Version',
  restart: 'Restart',
  newUpdateHint: 'New update released, version',
  newUpdateAlreadyHint: 'You’ve updated to a version',
  updateOk: 'Close',
  reload: 'Update and reload',

  notifyPeople: 'Notify these people:',
  nobodyNotified: 'Nobody is notified!',
  nobodyNotifiedExceptYou: 'Nobody is notified, except you!',
  changePass: 'Change password',
  changeEmail: 'Change e-mail',
  typeNewPass: 'Type a new password',
  newPassShort: 'New password is too short',
  newPassEmpty: 'New password should not be empty',
  typeOldPass: 'Type your old password',
  incorrectOldPass: 'Incorrect old password',
  passChangeOk: 'Password changed successfully',
  newPass: 'New password',
  oldPass: 'Old password',
  savePass: 'Save password',
  yourLang: 'Your language:',
  displayedName: 'Displayed name…',
  uploadNewPhoto: 'Upload a new photo…',
  imageTypeUnsupported: 'The image type is not supported (only png and jpeg)',
  freeTariffWarning:
    "Your company's paid license has expired. Recent system actions will not be saved. Contact your administrator.",
  freeTariffWarningForAdmin:
    "Your company's paid license has expired. Recent system actions will not be saved. Update your license or remove unnecessary users.",
  turnOffNotifications: 'Turn off notifications',
  min30: 'For 30 minutes',
  hour1: 'For 1 hour',
  hour2: 'For 2 hours',
  hour4: 'For 4 hours',
  hour8: 'For 8 hours',
  hour24: 'For 24 hours',
  notificationsSnoozed: 'Notifications are snoozed until',
  turnOnNotifications: 'Turn on notifications',
  noNotifications: 'No new notifications',
  myConversations: 'My conversations',
  othersConversations: 'Other’s conversations',
  markAsSeen: 'Mark as seen',
  confirmBoardDelete: 'Delete this board?',
  moreNewTasks: 'More new tasks:',
  moreTasks: 'There are more tasks:',
  moreUsers: 'More users:',
  archivedTasks: 'Archived tasks',
  taskPlaceholder: 'Type a task text…',
  confirmDeleteTask: 'Are you sure you want to delete this task?',
  msgHint: 'Chat messages, click to open the chat',
  deleteTask: 'Delete the task',
  editTask: 'Edit the title of the task',
  createColumn: 'Create a new column',
  columnPlaceholder: 'Type a column name…',
  addMirror: 'Create a mirror',
  mirror: 'Mirror',
  chooseColumns: 'Choose columns:',
  mirrorColumn: 'Mirror',
  mirrorColumnDefaultTitle: 'Mirror',
  reportColumn: 'Report',
  pinStickerToColumn:
    'Do you want to pin this sticker ' + 'to all shown tasks in this column?',
  pinStickerToColumnUnavailable:
    'This sticker can be pinned only to individual task',
  clickTaskConnect: 'Click on a task to link it with',
  clickToConnect: 'Click to link this task with another task',
  clickDisconnect: 'Click to unlink the tasks',
  confirmDisconnect: 'Delete the link to the task?',
  created: 'Created',
  byUser: 'by ',
  atTime: 'at ',
  openDirectChat: 'Open direct chat',
  directChatVisibleOnly: 'This chat is visible only to you and',
  msgSeenEverybody: 'Everybody saw this message',
  msgSeenNobody: 'Nobody saw this message',
  msgSeenSomebody: 'This message has been seen by',
  connectedTasks: 'Linked tasks',
  alreadyAddedStickerBoard: 'Already added to the board',
  removeFromBoard: 'Remove from the board',
  removeFromTask: 'Remove from task',
  chooseStickerType: 'Choose a type of the new sticker:',
  stickerText: 'Sticker with text value',
  stickerNumeric: 'Numeric value sticker',
  stickerString: 'Sticker with text states',
  stickerStringExp: '– good for adding some category information to tasks.',
  stickerStringEg: 'E.g.: priority, product, subsystem, etc.',
  stickerSprint: 'Sticker sprint',
  stickerSprintExp:
    '– for attaching tasks to time intervals (iterative process).',
  stickerSprintEg: 'E.g.: scrum sprints, week plans, etc.',
  stopwatchExp: `– for attaching a clock to a task, this clock can be paused
                 and resumed and it can show how much time
                 was spent on the task.`,
  timerExp: `– you can set a time for any task and this sticker will start a
              countdown, everyone will know how much time left for the task.`,
  deadlineExp: `– allows to add a deadline to your tasks.`,
  userExp: `– with this sticker you can assign a person that is added to
              your project to your tasks.`,
  timetrackingExp: `– adds time tracking features to a board`,
  orAddStickerFromOtherBoard: 'Or add a sticker from another board:',
  stopwatchHeader: 'Stopwatch sticker',
  timerHeader: 'Timer sticker',
  deadlineHeader: 'Deadline sticker',
  timetrackingHeader: 'Time tracking sticker',
  userHeader: 'User sticker',
  chooseSticker: 'choose a sticker',
  deleteSticker: 'Delete the sticker',
  deleteStickerHead: 'Delete this sticker',
  deleteStickerBoard: 'Delete from this board',
  deleteStickerFull: 'Delete from the entire system',
  deleteGroupWarn: 'Delete this column?',
  deleteGroupWarnHint:
    'When you delete a column, all tasks in it will also be deleted',
  deleteMirrorWarn: 'Delete the mirror column?',
  deleteMirrorWarnHint:
    'When you delete the mirror, the column itself will not be deleted',
  weCreatedExampleStates: `We’ve created a couple of example states for you.
                           You can use, modify or delete them.`,
  stickerName: 'Sticker name:',
  stickerFilterName: 'Title',
  sticker: 'Sticker',
  none: 'None',
  boardSettingsMain: 'Main',
  boardSettingsAppearance: 'Appearance',
  boardSettingsStickers: 'Stickers',
  boardSettingsSharing: 'Link access',
  boardSettingsMoveTasks: 'Move tasks',
  boardSettingsTaskTemplate: 'Task templates',
  boardSettingsGantt: 'Gantt',
  notEnoughPermissions:
    'You do not have sufficient rights to access this section',
  unknownError: 'Unknown error, please try again later',
  stickerNameIcon: 'Sticker name and icon:',
  stickerPlaceholder: 'Type a sticker…',
  stickerStates: 'Sticker states:',
  stickerStates2: 'States',
  stickerNoName: 'Please, enter a name for this sticker',
  editSticker: 'Edit sticker',
  addRemoveSticker: 'Add/remove sticker',
  quickLinks: 'Quick links',
  createStickerIn: 'Create a new sticker in ',
  removeAdmin: 'Remove admin privileges',
  addAdmin: 'Add admin privileges',
  latestActivity: 'Latest activity',
  inviteUser: 'Invite a new user',
  addUserToProjects: 'Add the user to these projects',
  addUserToProjects2: 'Add invited users to projects',
  addInvitationText: 'Add invitation text',
  deleteCompany: 'Delete the company',
  deleteContact: 'Are you sure you want to delete this contact?',
  companiesList: 'Companies',
  company: 'Company',
  renameCompany: 'Rename company',
  delCompany: 'Delete company',
  configureCompany: 'Configure Company',
  configureCompany2: 'Configure the Company',
  configureCompany3: 'Open configurator for current company',
  companyPlaceholder: 'Company name',
  addCompany: 'Add a company',
  addContactAndProjects: 'Add to projects',
  addContactHint:
    'Please specify an e-mail of the person you want to add. ' +
    'You can then start to chat with the new contact immediately.',
  successAddedContact: 'You’ve successfully added',
  successAddedContact2: 'to your direct messages contact list.',
  createCompany: 'Create a new company',
  createCompanyHint: 'Enter a new company name, example: “Apple Inc.”',
  directMsg: 'Direct messages',
  searchMsgPlaceholder: 'Search messages and contacts',
  msgHistory: 'Messages history',
  contacts: 'Contacts',
  searchResults: 'Search Results',
  searchResultsLimited: (count: string | number) =>
    `First 300 items of ${count} are shown. Change your request to see more relevant results.`,
  searchResultsShowAll: 'Show all',
  searchResults2:
    'No tasks were found that satisfied the filtering conditions. Change the query or change the filter',
  searchResults3: 'Search results in other filters:',

  addContactByEmail: 'Add a new contact by e-mail',
  allDirectChats: 'All chats and contacts',
  feedbackTitle: 'Help, feedback, news',
  addFeedback: 'Add a new request',
  fbOpen: 'Open',
  fbClosed: 'Closed',
  fbTitle: 'Title',
  fbMessage: 'Message',
  fbAddRequest: 'Add the request',
  profilePath: 'Direct messages »',
  feedbackPath: 'Feedback »',
  mspSuccess: 'Your e-mail settings were successfully changed',
  mailSettingsHead: 'E-mail settings for',
  mspGetNews: 'receive e-mails about new updates',
  mspGetNotifications: 'receive e-mail notifications about new chat messages',
  mspNotifyOften: 'no restrictions (default)',
  mspNotifyHourly: 'no more than 1 e-mail per hour',
  mspNotifyDaily: 'no more than 1 e-mail per day',
  mailReply: 'Reply in YouGile',
  noConnectionShort:
    'Can’t reach the server. ' + 'Please, check your internet connection.',
  noConnection:
    'Can’t reach the server. ' +
    'Please, check your internet connection. After connection recovery all ' +
    'the changes will be transferred to the server',
  removeLastAdminWarn:
    'Can’t remove last admin in this company. Mark some ' +
    'other user as admin before removing admin privileges of this user.',
  addedUsers: (count: number): string => `Added ${count} users.`,
  removedUsers: (count: number): string => ` Removed ${count} users.`,
  noChangesUsers: 'No changes, choose users on the right',
  sprintStickerAutoSort: 'States of “Sprint” stickers are sorted automatically',
  egBoard: 'My First Board',
  egCol1: 'Training TODO',
  egCol2: 'Important tasks',
  egT1: 'Sign up',
  egT2: 'Create a new project',
  egT3: 'Create a new board',
  egT4: 'Add your teammate to the project',
  egT5: 'Write a message in this task’s chat',
  egT6: 'Pin Priority “Major” sticker to this task',
  egT7: 'Add a new task',
  egT8: 'Move this task to the new column',
  egT9: 'Add a new column',
  egT10: 'Mark this task as completed',
  egMsg: `
        Hi! Each task in YouGile is a chat.
        Communications in your team now will be structured.
        Welcome to YouGile!
      `,
  tasks: 'Tasks',
  taskChats: 'Tasks chats',
  personalChats: 'Personal',
  settings: 'Settings',
  settingsAndBg: 'Settings / Set background',
  profile: 'Profile',
  edit: 'Edit',
  writeMessage: 'Write a message',
  willReceiveNotificationsPlural: 'Will be notified',
  online: 'online',
  offline: 'offline',
  changeName: 'Change name',
  changePassword: 'Change password',
  changeAvatar: 'Change avatar',
  generalPlural: 'General',
  disableNotifications: 'Disable notifications',
  enabledPlural: 'Enabled',
  disabledPlural: 'Disabled',
  postOnEnter: 'Send on Enter',
  myChats: 'my chats',
  otherChats: 'other chats',
  emptyOtherChatsNotice: LangUtil.stripMargin(`
    No chats yet.

    Here will be all chats where you were not added to the notification list.
  `),
  newContact: 'New contact',
  emptyPersonalChatsNotice: LangUtil.stripMargin(`
    No contacts yet.

    You can add a new contact and start a conversation right now.
  `),
  language: 'Language',
  createQuickLink: 'Create a quick link',
  editQuickLink: 'Edit the quick link',
  enterQuickLink: 'Enter a name of the quick link',
  noConnectionMobile: 'No internet connection',
  noServer: 'Server is not reponding',
  reconnect: 'reconnect',
  createProject: 'Create a project',
  projectName: 'Project name',
  idProject: 'Prefix ID task',
  idProjectBusy: 'A project with the same ID already exists',
  idProjectBusyBySystem: 'Prefix ID already busy',
  idProjectInvalid: 'Only Latin letters and numbers',
  unread: 'Unread',
  stickersFiltration: 'Filtration by sticker',
  filtration: 'Filtration',
  customizeTable: 'Customize table',
  noTasks: 'There are no tasks in the list',
  emptyTasksList: 'The list is empty. Create (+) or drag a task here',
  tasksNotFoundByFilters:
    'No tasks were found that satisfied the filtering conditions. Reset filters',
  tasksListAvailableOnlyForYou: 'The list is available only to you',
  tasksListAvailableOnlyForYouHint:
    'Private tasks are visible only to you; other users cannot find or open them.',
  availableTableColumns: 'Available table columns',
  filter: 'Filter',
  filterBySticker: 'Filter',
  rename: 'Rename',
  renameId: 'Change project ID prefix',
  delete: 'Delete',
  bind: 'Connect',
  openChat: 'Open chat',
  confirmDeleteGroup: 'Are you sure you want to delete this column?',
  confirmation: 'Confirmation',
  deleteListWithTasks: 'Delete a list of tasks',
  deleteListWithTasksConfirmation:
    'When you delete a list, all tasks in it will also be deleted. Continue deletion?',
  error: 'Error',
  openEdit: 'Open / Edit',
  currentCompany: 'Сurrent company',
  changeCompanyLabel: 'Change company',
  doNotDisturbMode: '"Do not disturb" mode',
  doNotDisturb: 'Do not disturb',
  notificationsAndSounds: 'Notifications and sounds',
  notifications: 'Notifications',
  shakeForFeedback: 'Shake for feedback',
  feedbackAndHelp: 'Feedback and help',
  disabled: 'Disabled',
  enabled: 'Enabled',
  profileUpdateSuccessful: 'Your profile was updated successfully',
  title: 'Title',
  problemDescription: 'Problem description',
  messageSent: 'Message delivered',
  thanksMessageSent: 'Thanks, your message was sent to developers',
  openTickets: 'Open tickets',
  closedTickets: 'Closed tickets',
  attachFile: 'Attach file to message',
  addGroup: 'Add column',
  enterProjectName: 'Enter project name',
  enterBoardName: 'Enter board name',
  enterGroupName: 'Enter column name',
  enterTaskName: 'Enter task name',
  selectCompany: 'Select company',
  createBoard: 'Create board',
  deleteBoard: 'Delete board',
  renameBoard: 'Rename board',
  done: 'Done',
  clean: 'Clean',
  emptyProjectNotice: (name: string) => {
    return `There are no boards in your "${name}" project.`
  },
  addToProject: 'Add to project',
  emailGreeting: (name: string): string => `Hi ${name},\n`,
  unseenSubject: (date: string): string => `New unread messages (${date})`,
  unseenPreview: (count: number, chats: number): string =>
    `messages: ${count}, chats: ${chats}`,
  unseenText1: (count: number, chats: number): string =>
    `You have ${count} new unseen messages (in ${chats} chats):`,
  unseenText11: 'You have ',
  unseenText12: (chats: number): string =>
    ` new unseen messages (in ${chats} chats):`,
  resetPasswordSubject: 'Reset your password',
  resetPasswordPreview: 'Follow the [link] to set a new password',
  resetPassText1:
    'There was a password reset request for your Yougile ' + 'account.',
  resetPassText2: 'To set your new password, please follow',
  resetPassText3: 'this link',
  resetPasswordTextBody: (name: string, url: string): string =>
    LangUtil.stripMargin(`
      Hi ${name},

      There was a password reset request for your Yougile account.
      To set your new password, follow the link below:
      ${url}
  `),
  emailTextFooter: (unsubscribeLink: string): string =>
    LangUtil.stripMargin(`
      --
      Best Regards,
      YouGile team.


      (To unsubscribe from YouGile e-mails follow the link:
       ${unsubscribeLink})
  `),
  changeCompany(name: string): string {
    return `Change “${name}” company settings`
  },
  taskNoun: {
    one: 'task',
    other: 'tasks',
    few: 'tasks'
  } as PluralNoun,
  // accusative case
  taskNounAcc: {
    one: 'task',
    other: 'tasks'
  } as PluralNoun,
  triesNoun: {
    one: 'try',
    other: 'tries'
  } as PluralNoun,
  messageNoun: {
    one: 'message',
    other: 'messages'
  } as PluralNoun,
  newNoun: {
    one: 'new',
    other: 'new'
  } as PluralNoun,
  newNounFemale: {
    one: 'new',
    other: 'new'
  } as PluralNoun,
  fileNoun: {
    one: 'file',
    other: 'files'
  } as PluralNoun,
  dayNoun: {
    one: 'day',
    other: 'days'
  } as PluralNoun,
  hourNoun: {
    one: 'hour',
    other: 'hours'
  } as PluralNoun,
  minuteNoun: {
    one: 'minute',
    other: 'minutes'
  } as PluralNoun,
  remainedNoun: {
    one: 'remained',
    other: 'remained'
  } as PluralNoun,
  personNoun: {
    one: 'person',
    other: 'people'
  } as PluralNoun,
  companyNoun: {
    one: 'company',
    other: 'companies'
  } as PluralNoun,
  boardNoun: {
    one: 'board',
    other: 'boards'
  } as PluralNoun,
  projectNoun: {
    one: 'project',
    other: 'projects'
  } as PluralNoun,
  ratingNoun: {
    one: 'rating',
    other: 'ratings'
  } as PluralNoun,
  commentNoun: {
    one: 'comment',
    other: 'comments'
  } as PluralNoun,
  ratingsCount(count: number): string {
    return `${count} ${langEn.ratingNoun[plural('en', count)]}`
  },
  commentsCount(count: number): string {
    return `${count} ${langEn.commentNoun[plural('en', count)]}`
  },
  selectedCompanies(companies: number): string {
    return `${companies} ${langEn.companyNoun[plural('en', companies)]}`
  },
  selectedBoards(boards: number): string {
    return `${boards} ${langEn.boardNoun[plural('en', boards)]}`
  },
  selectedProjects(projects: number): string {
    return `${projects} ${langEn.projectNoun[plural('en', projects)]}`
  },
  projectTasks(tasks: number): string {
    return `${tasks} ${langEn.taskNoun[plural('en', tasks)]}`
  },
  newTasks(tasks: number): string {
    return `${tasks} ${langEn.newNoun[plural('en', tasks)]} ${
      langEn.taskNoun[plural('en', tasks)]
    }`
  },
  newMessages(messages: number): string {
    return `${messages} ${langEn.newNoun[plural('en', messages)]} ${
      langEn.messageNoun[plural('en', messages)]
    }`
  },
  projectMessages(messages: number): string {
    return `${messages} ${langEn.messageNoun[plural('en', messages)]}`
  },
  projectNewMessages(messages: number): string {
    return `${messages} ${langEn.newNoun[plural('en', messages)]}`
  },
  projectFiles(files: number): string {
    return `${files} ${langEn.fileNoun[plural('en', files)]}`
  },
  projectStats(tasks: number, messages: number, files: number): string {
    return (
      `${langEn.projectTasks(tasks)}, ` +
      `${langEn.projectMessages(messages)}, ${langEn.projectFiles(files)}.`
    )
  },
  deadlineNoticeDays(days: number): string {
    return (
      `${days} ${langEn.dayNoun[plural('en', days)]} ` +
      `remained until deadline!`
    )
  },
  deadlineNoticeHours(hours: number): string {
    return (
      `${hours} ${langEn.hourNoun[plural('en', hours)]} ` +
      `remained until deadline!`
    )
  },
  deadlineNoticeMinutes(minutes: number): string {
    return (
      `${minutes} ${langEn.minuteNoun[plural('en', minutes)]} ` +
      `remained until deadline!`
    )
  },
  severalMinutes(minutes: number): string {
    return `${minutes} ${langEn.minuteNoun[plural('en', minutes)]}`
  },
  severalHours(hours: number): string {
    return `${hours} ${langEn.hourNoun[plural('en', hours)]}`
  },
  severalDays(days: number): string {
    return `${days} ${langEn.dayNoun[plural('en', days)]}`
  },
  deadlineAlert: 'Deadline has expired',
  dateNotSet: 'Date is not set',
  settingDeadline: 'Setting deadline',
  at: 'at',
  saved: 'Saved!',
  notifyBefore: 'Notify before',
  withTime: 'Set time',
  goToTask: 'Go to task',
  projectsAndTasksHeader: 'Projects and tasks',
  taskChatsHeader: 'Task chats',
  userWrote: (name: string) => name + ' wrote:',
  registerEmailText(inviter: string, url: string, text: string): string {
    if (text) {
      return LangUtil.stripMargin(`
        User ${inviter} invited you to a project.

        ${inviter} wrote:
        “${text}”

        To proceed with the project follow the link bellow:
        ${url}
      `)
    } else {
      return LangUtil.stripMargin(`
        User ${inviter} invited you to a project.

        To proceed with the project follow the link bellow:
        ${url}
      `)
    }
  },
  registerText1: (inviter: string): string =>
    `User ${inviter} invited you to a project.`,
  registerText2: 'To proceed with the project follow',
  registerText3: 'this link',
  emailReason: `You’ve received this e-mail because
                you are registered in YouGile`,
  setupMail: 'Change Yougile e-mail notification settings',
  unsubscribe: 'Unsubscribe from YouGile e-mails',
  inviteReason: (inviterEmail: string): string => `
    You’ve received this e-mail because you was invited by YouGile user
    with e-mail ${inviterEmail}
  `,
  inviteCompanySubject: (companyName: string) =>
    `You were invited to company “${companyName}”`,
  inviteCompanyPreview: 'New project is available in YouGile',
  inviteCompanyEmailText(
    inviter: string,
    url: string,
    companyTitle: string,
    text: string
  ): string {
    if (text) {
      return LangUtil.stripMargin(`
        User ${inviter} added you as a member of “${companyTitle}” company.

        ${inviter} wrote:
        “${text}”

        You can now participate in this company with your YouGile
        account (${url}).
      `)
    } else {
      return LangUtil.stripMargin(`
        User ${inviter} added you as a member of “${companyTitle}” company.

        You can now participate in this company with your YouGile
        account (${url}).
      `)
    }
  },
  inviteText1: (inviter: string, companyTitle: string): string =>
    `User ${inviter} added you as a member of “${companyTitle}” company.`,
  inviteText2: 'You can now participate in this company with your',
  inviteText3: 'YouGile account',
  registerPartnerSubject: 'YouGile partner program registration',
  registerPartnerText:
    'To proceed with the registration on YouGile, ' +
    'please follow the link bellow:',
  registerPartnerEmailText(link: string): string {
    return LangUtil.stripMargin(`
                To proceed with the registration on YouGile,
                please follow the link bellow:
                ${link}
              `)
  },
  registerRequestEmailText(link: string): string {
    return LangUtil.stripMargin(`
              To proceed with the registration on YouGile,
              please follow the link bellow:
              ${link}
            `)
  },
  registerRequestEmailSubject: 'Registration in YouGile',
  registerRequestText:
    'To proceed with the registration on YouGile, ' +
    'please follow the link bellow:',
  registerButtonText: 'Continue registration',
  boxRequestEmailText(link: string, os: string, docsLink: string): string {
    return LangUtil.stripMargin(`
      Download installer (${os}) from this link:
      ${link}

      Setup instructions:
      ${docsLink}
    `)
  },

  boxRequestLinuxEmailText(
    rhelLink: string,
    debianLink: string,
    instructionsLink: string
  ): string {
    return LangUtil.stripMargin(`
      For RHEL, CentOS, CloudLinux use this link for installer:
      ${rhelLink}

      For Debian, Ubuntu and other Linux Distros use:
      ${debianLink}

      Setup instructions:
      ${instructionsLink}
    `)
  },

  changeEmailPrevSubject: 'Email change',
  changeEmailPrevPreview: 'Email change',
  changeEmailPrevText1: (name: string, newEmail: string): string =>
    `Hi ${name}, Your YouGile account email has been changed to ${newEmail}.`,
  changeEmailPrevText2:
    'If you have not requested it, contact support: support@yougile.com',
  changeEmailPrevTextBody: (name: string, newEmail: string): string =>
    LangUtil.stripMargin(`
    Hi ${name},

    Your YouGile account email has been changed to ${newEmail}.
    If you have not requested it, contact support: support@yougile.com
    `),
  changeEmailNewSubject: 'Email change',
  changeEmailNewPreview: 'Email change',
  changeEmailNewText1: (name: string): string =>
    `Hi, ${name}! To finish changing your email, `,
  changeEmailNewText2: 'follow the link',
  changeEmailNewTextBody: (name: string, link: string) =>
    `Hi, ${name}! To finish changing your email, go to the following link: ${link}`,

  boxRequestEmailSubject: 'Self-hosted installer',
  boxRequestText: 'Download installer:',
  boxRequestText2: 'Setup instructions:',
  boxRequestText3:
    'Documentation for writing extensions on the YouGile Platform:',
  scripts: 'Scripts',
  addScriptHint: 'Add a new script',
  uploadScriptHint: 'Upload a script from your computer',
  runScriptHint:
    'Run/reload this script locally ' + '(other users are not affected)',
  saveScriptHint: 'Save this script',
  enabledScriptHint: 'This script starts on page load for everyone',
  disabledScriptHint: 'This script don’t start on page load',
  yourScripts: 'Your scripts',
  scriptNamePlaceholder: 'Enter a script name …',
  noScripts1: 'No scripts yet,',
  noScripts2: 'add a script',
  openScriptHint: 'Open this script',
  enabledScript: 'enabled',
  disabledScript: 'disabled',
  addMarketplace: 'Add to marketplace',
  renameScript: 'Rename script',
  scriptPresets: 'Script examples',
  approvedScript: 'approved',
  notApprovedScript: 'not approved',
  notAssigned: 'Not assigned',
  apiNavigator: 'API navigator',
  objectNavigator: 'Object navigator',
  apiHelp: 'Help',
  helpTitle: 'Help',
  insertToCode: 'Insert into code',
  editInScript: 'edit in script',
  usageExample: 'Usage example',
  openEditorWarn:
    'Open a script where you want to insert this object ' + 'before inserting',
  onlyJsAllowed: 'Only .js extension is allowed',
  confirmAddMarketplace: 'Really add this script to the marketplace?',
  confirmDeleteScript: (name: string) => `Delete “${name}” script?`,
  confirmCloseUnsaved:
    'You have unsaved changes in this script. ' +
    'Do you wish to close and discard all changes?',
  objNavHint: 'Drag and drop objects to the editor',
  helpWriteUs1: 'Write us in a chat!',
  helpWriteUs2: `
    – you can start a chat with us.
    We are looking forward to hear some
    feedback from you and ready to help
    with difficulties / bugs!`,
  helpWatchVid1: 'Watch the video',
  helpWatchVid2: `
    – here is a 10 min video with some real-world
    customization script examples.`,
  helpReadMan1: 'Read the manual pdf',
  helpReadMan2: `
    – it’s just a couple of pages but after you read it you can
    get a better understanding of the API and how to use it.`,
  apiAppCopy: 'copy to your scripts',
  readonlyScriptWarn: 'Readonly. Copy script to your scripts to edit.',
  deleteMsg: 'Delete this message',
  reactMsg: 'React to this message',
  confirmDeleteBg: 'Really delete this background?',
  newCompanyAvailable:
    'New company is available, after reloading you’ll be able to choose it.',
  mobileAppBannerTitle: 'YouGile 2.0 Mobile App',
  mobileAppBannerTitleAdmin: 'With the app, your team gets into action ',
  mobileAppBannerTextAdmin: "faster — proven by 10,000 companies' experience",
  mobileAppBannerTitleNotAdmin: "Now it's even easier to manage tasks",
  mobileAppBannerTextNotAdmin: 'and chat',
  androidApp: 'Mobile App',
  androidAppDetails: 'iOS and Android. Download »',
  androidAppTitle: 'YouGile App is available for iOS and Android.',
  androidAppText1:
    'The app allows to do almost all activities that are available in web ' +
    'application. Push notifications allow to be notified on new messages ' +
    'even when the app is turned off.',
  androidAppText2: 'Stay connected with your team everytime!',
  androidAppDownload: 'Download it on Google Play',
  androidAppDownloadApple: 'Download on the App Store',
  androidAppBtn1: 'Don’t show this anymore',

  desktopApp: 'Desktop App',
  desktopAppDetails: 'Win, Mac, Linux. Download »',
  desktopAppBtn: 'Don’t show this anymore',
  desktopAppTitle: 'Download YouGile App',

  noDeleteLastBoard:
    'You can’t delete last board in a project, ' +
    'add some new board first to delete this board.',
  addChecklist: 'Create a checklist',
  checklistPlaceholder: 'Checklist name…',
  sureDeleteChecklist: 'Delete this checklist?',
  sureDeleteChecklistHint:
    'When you delete a checklist, all items in it will also be deleted',
  addSubtask: 'Add an item',
  subtaskPlaceholder: 'Subtask text…',
  checklistItemPlaceholder: 'Item text…',
  checklistDel: 'Delete checklist',
  checklistItemDel: 'Delete subtask',
  checklistItemDelIssue: 'Delete item',
  connectTaskWith: 'Add a link',
  unlink: 'Unlink',
  editNotSaved1: 'You didn’t save last changes. ',
  editNotSaved2: ' or ',
  editNotSaved3: '?',
  editSee: 'See changes',
  editDiscard: 'Discard',
  newsTitle: 'News and Updates',
  addNewsItem: 'Add a new update',
  newsColumnHint:
    'Here we post news and update information. ' +
    'Conversations in all cards in this column are public.',
  newsChatVisibility: 'This chat is visible to all users',
  prjParticipants: 'Users in project',
  fullUserList: 'Show more...',
  chooseUserFromLIst: 'Choose users from list',
  addUserByEmail: 'Invite new users by e-mail',
  enterEmailsToInvite: 'Enter e-mails to invite people',
  inviteEmailIncorrect: 'Incorrect e-mail, invitation will not be sent',
  inviteEmailExists: 'User already invited, new invitation will be sent',
  addStickerHint: 'Add a new sticker',
  enterBoxUrl: 'Enter custom server address\n(for self-hosted YouGile)',
  enterBoxUrlError: 'Incorrect custom server url',
  boxUrlIs(url: string): string {
    return `Server url is set to ${url}`
  },
  recoveryInvalidLink:
    'The link you’ve followed is incorrect or no longer valid.',
  recoveryTitle: 'Password reset',
  recoveryNewPass: 'Your new password',
  recoveryNewPassPl: 'Enter your new password…',
  recoveryRetypePass: 'Retype the password',
  recoveryRetypePassPl: 'Type the password again…',
  recoveryChangePass: 'change password',
  recoveryPassEmpty: "Password field shouldn't be empty",
  recoveryPassShort: 'Password is too short',
  recoveryPassNoMatch: 'Passwords do not match',
  recoveryError: 'An error occurred, please try again later',
  recoveryUnknownError: 'Unknown error, please try again later',
  registerTitle: 'Create an account',
  filtering: 'filtering',
  filterHint: 'Choose the sticker to filter the board',
  chooseDates: 'choose a date interval',
  editorCloseConfirm:
    'You have unsaved changes. Are you sure you want to ' +
    'close the tab? All changes will be lost.',
  stats: 'Statistics',
  ttEstimation: 'Estimation',
  ttSpent: 'Spent time',
  ttEnterEstimation: 'Enter estimated time',
  ttLeaveNoPlan: 'Leave task without plan',
  ttFillToClose: 'Fill this to close task',
  ttClosedIf: 'Consider tasks closed if it is in column',
  ttExcludeIf: 'Exclude column from timetracking',
  newTasks1: 'There are ',
  newTasks2: ' new tasks in this board.',
  tsTasksRemain: 'Tasks remain',
  tsTasksClosed: 'Tasks closed',
  tsHoursRemain: 'Hours remain',
  tsHoursClosed: 'Hours closed',
  tsOpen: 'Open',
  tsClosed: 'Closed',
  tsAll: 'All tasks',
  tsUser: 'User',
  tsTaskName: 'Task name',
  up: 'Up',
  tsPlan: 'Plan',
  tsWork: 'Work',
  tsCreated: 'Created',
  tsCloseDate: 'Closed',
  tsDownloadXLSX: 'Download Excel spreadsheet',
  tsStats: 'Statistics…',
  tsTaskCount: 'Number of tasks',
  tsTaskHours: 'Planned hours',
  tsKeyOpen: 'open',
  tsKeyClosed: 'closed',
  tsRange: 'Range',
  tsTitle: 'Statistics',
  connections: 'Links',
  wantToDeleteATask: 'Delete a task?',
  wantToDeleteAMirror: 'Want to delete a mirror?',
  dateFormat: 'MM/DD/YY',
  timeFormat: 'hh:mm',
  yesterday: 'Yesterday',
  todayFormat: 'Today, hh:mm',
  yesterdayFormat: 'Yesterday, hh:mm',
  you: 'You',
  search: 'Search',
  searchCompany: 'Search in company',
  closeSearch: 'Close search',
  duplicate: 'Duplicate',
  allProjectsAndPermissions: 'All projects and permissions',
  groupChats: 'Group chats',
  uploadFile: 'Upload file',
  uploadImage: 'Upload image',
  actionWithMessage: 'Action with message',
  copy: 'Copy',
  pin: 'Pin',
  newGroup: 'New column',
  newBoard: 'New board',
  newTask: 'New task',
  sendToChat: 'Send to chat',
  subtasks: 'Subtasks',
  yourCompanies: 'Your companies',
  chatWithUser: 'Chat with user',
  notFound: 'Not found',
  addUser: 'Add user to company',
  addingUsers: 'Add user to company',
  editUsers: 'Edit users',
  askRemoveAdmin: 'Are you sure you want to remove this user from admins?',
  askAddAdmin: 'Are you sure you want to make this user admin?',
  success: 'Done successfully',
  noProjectsChosenError:
    'Please, select at least one project where user will be added',
  noUsersChosenError: 'Please, select at least one user',
  deleteUser: 'Delete user from the current company?',
  operationUnavailable: 'Operation is unavailable',
  newProject: 'Create New Project',
  myChatsFilter: 'Chats where I subscribed',
  otherChatsFilter: 'Chats where I’m not subscribed',
  assignedToMeChatsFilter: 'Only tasks assigned to you',
  emptyChatsFilter: 'Without messages',
  personalChatsFilter: 'Personal chats',
  setupCompanies: 'Companies settings…',
  boardBackground: ' Board background',
  videoTutorialTitle: 'Video Tutorial',
  reloadScriptsForAllUsers: 'Reload all scripts for all users in the company',
  reloadScriptsConfirm:
    'Are you sure you want to reload ' +
    'all scripts for all users in the company?',
  showOtherUsers: 'Show other users…',
  usersNotInProject: 'Users not in project',
  download: 'Download',
  forWin: 'YouGile for Windows',
  forMac: 'YouGile for Mac OS X',
  forLinux: 'YouGile for Linux (x64)',
  goUp: 'go up',
  move: 'Move',
  specifyDestination: 'Specify Destination...',
  createTaskMovementRule: 'Create task movement rule...',
  boards: 'Boards',
  columns: 'Колонки',
  chosenColumns: 'Chosen columns',
  newMsgInOtherCompanies: 'New messages in other companies',
  newColumn: 'New column',
  stickerPriority: 'Priority',
  majorPrio: 'Major',
  normalPrio: 'Normal',
  minorPrio: 'Minor',
  largeColumn: 'Column is too large (> 1000 tasks), skipping',
  confirmDuplicateProject: 'Duplicate this project?',
  companyAdded: 'Company added successfully',
  unnamed: 'Unnamed',
  collapseBoardHeader: 'Collapse board header',
  addFirstTask: 'Add your first task',
  onboardingVideo1: 'You’ve made a first step!',
  onboardingVideo2: 'Watch video tutorial:',
  onboardingVideo3: '92 features in 11 minutes',
  onboardingNoTasks1: 'Chats',
  onboardingNoTasks2: 'This is a list of your chats.',
  onboardingNoTasks2_5: 'It’s empty, you haven’t created any chats by now.',
  onboardingNoTasks3: 'Create task',
  onboardingNoTasks4: 'or',
  onboardingNoTasks5: 'invite people to your company',
  onboardingNoUsers1: 'User list is empty.',
  onboardingNoUsers2: 'Invite people here!',
  onboardingSingleTask1: 'Great, you’ve created a new task!',
  onboardingSingleTask2: 'Click on it to open a chat.',
  closeWnd: 'Close window',
  permissionsSetupGeneral: 'Company settings',
  permissionsObjectExists: 'This object is already added to the group',
  permissionsChooseProject: 'Choose project',
  permissionsObjectsHeader: 'Object',
  permissionsObjectSettingsHeader: 'Permissions for the object',
  permissionsUsersSave: 'Save selected users',
  permissionsFullAccess: 'Full access',

  permissionsForbiddenProjectDelete:
    'This project deletion is forbidden ' +
    'to you, please contact administrator of your company',
  permissionsForbiddenBoardDelete:
    'This board deletion is forbidden ' +
    'to you, please contact administrator of your company',
  permissionsForbiddenColumnDelete:
    'This column deletion is forbidden ' +
    'to you, please contact administrator of your company',
  permissionsForbiddenTaskDelete:
    'This task deletion is forbidden ' +
    'to you, please contact administrator of your company',
  permissionsForbiddenRename:
    'Renaming of this item is forbidden to you,' +
    'please contact administrator of your company',
  permissionsForbiddenMove:
    'Moving this item here is forbidden to you,' +
    'please contact administrator of your company',

  permissionsForbiddenCreateMirrorP1:
    'Dragging a task from the summary creates a mirror of the task.',
  permissionsForbiddenCreateMirrorP2:
    'You do not have permission to create a mirror on the board where the task is located. Contact your system administrator.',
  permissionsForbiddenCreateMirrorFromSubtaskP1:
    'Dragging a task from the summary creates a mirror of the task.',
  permissionsForbiddenCreateMirrorFromSubtaskP2:
    "You can't create a mirror from a subtask without a board. To create a mirror, move the subtask to the board, then create the mirror.",

  notSupportDragFromReportsP1:
    'Dragging a task from the summary creates a mirror of the task.',
  notSupportDragFromReportsP2:
    'Creating mirrors from a summary column is not supported by your server version',

  permissionsForbiddenEditDescription:
    'Changing this description is forbidden to you,' +
    'please contact administrator of your company',
  permissionsForbiddenTaskClose:
    'Closing and opening this task is forbidden to you,' +
    'please contact administrator of your company',
  permissionsForbiddenAssignUser:
    'Assigning this user to this task is forbidden to you,' +
    'please contact administrator of your company',
  permissionsForbiddenTaskStickers:
    'Changing this task stickers is forbidden to you,' +
    'please contact administrator of your company',
  permissionsForbiddenTaskConnect:
    'Linking these tasks is forbidden to you,' +
    'please contact administrator of your company',
  permissionsFobiddenTaskComplete:
    'Not enough permissions to change completeness of this task',
  permissionsForbiddenEditSubtasks:
    'Editing subtasks of this task is forbidden to you,' +
    'please contact administrator of your company',
  permissionsForbiddenSendFiles:
    'Sending files in this chat is forbidden to you,' +
    'please contact administrator of your company',
  permissionsForbiddenEditWhoToNotify:
    'Changing notification for this user in this chat is forbidden to you,' +
    'please contact administrator of your company',

  cannotMoveTaskColumnDeleted:
    'The task cannot be moved because the move column has been removed. Please, edit the Rule',

  cannotMoveTaskBoardDeleted:
    'The task cannot be moved because the move board has been removed. Please, edit the Rule',

  cannotMoveTaskProjectDeleted:
    'The task cannot be moved because the move project has been removed. Please, edit the Rule',

  taskIsOutOfFilters: 'To see the created task, turn off bord filtration',

  permissionsProject: 'Project',
  permissionsBoard: 'Board',
  permissionsColumn: 'Column',
  permissionsTask: 'Task',
  permissionsAllowAll: 'Allow all',
  permissionsDisallowAll: 'Disallow all',

  permissionsSettingsProjectDelete: 'Detele project',
  permissionsSettingsProjectEditTitle: 'Edit project title',
  permissionsSettingsProjectAddBoard: 'Add boards',
  permissionsSettingsProjectBoards: 'Boards',

  permissionsSettingsBoardDelete: 'Delete board',
  permissionsSettingsBoardEditTitle: 'Edit board title',
  permissionsSettingsBoardShowStickers: 'Show sticker panel',
  permissionsSettingsBoardEditStickers: 'Edit board stickers',
  permissionsSettingsBoardMove: 'Move board',
  permissionsSettingsBoardAddColumn: 'Add columns',
  permissionsSettingsBoardSettings: 'Managing main board settings',
  permissionsSettingsBoardColumns: 'Columns',

  permissionsSettingsColumnDelete: 'Delete column',
  permissionsSettingsColumnEditTitle: 'Edit column title',
  permissionsSettingsColumnMove: 'Move column',
  permissionsSettingsColumnMoveOptNo: 'Disallow',
  permissionsSettingsColumnMoveOptProject: 'Allow only inside project',
  permissionsSettingsColumnMoveOptYes: 'Allow',
  permissionsSettingsColumnAddTask: 'Add task',
  permissionsSettingsColumnAllTasks: 'All tasks',
  permissionsSettingsColumnWithMeTasks: 'Tasks with user in notifications',
  permissionsSettingsColumnMyTasks: 'Tasks assigned to user',
  permissionsSettingsColumnCreatedByMeTasks: 'Tasks created by user',

  permissionsSettingsTaskShow: 'Show task',
  permissionsSettingsTaskDelete: 'Delete task',
  permissionsSettingsTaskEditTitle: 'Edit task title',
  permissionsSettingsTaskEditDescription: 'Edit task description',
  permissionsSettingsTaskComplete: 'Complete/uncomplete tasks',

  permissionsSettingsTaskClose: 'Archive task',
  permissionsSettingsTaskAssignUsers: 'Assign users to task',
  permissionsSettingsTaskAssignUsersOptNo: 'Disallow',
  permissionsSettingsTaskAssignUsersOptAddSelf: 'Allow to add self if empty',
  permissionsSettingsTaskAssignUsersOptSetSelf: 'Allow to change any to self',
  permissionsSettingsTaskAssignUsersOptChangeFromSelf:
    'Allow to change from self to any',
  permissionsSettingsTaskAssignUsersOptYes: 'Allow',

  permissionsSettingsTaskConnect: 'Link tasks',
  permissionsSettingsTaskEditSubtasks: 'Edit checklists and list of subtasks',
  permissionsSettingsTaskEditSubtasksOptNo: 'Disallow',
  permissionsSettingsTaskEditSubtasksOptComplete:
    'Allow to complete checklists',
  permissionsSettingsTaskEditSubtasksOptYes: 'Allow',
  permissionsSettingsTaskEditStickers: 'Edit stickers and task color',
  permissionsSettingsTaskEditPins: 'Edit pins',
  permissionsSettingsTaskSendFiles: 'Send files in chat',
  permissionsSettingsTaskEditWhoToNotify: 'Edit users in chat notifications',
  permissionsSettingsTaskEditWhoToNotifyOptNo: 'Disallow',
  permissionsSettingsTaskEditWhoToNotifyOptSelf: 'Allow to change self',
  permissionsSettingsTaskEditWhoToNotifyOptYes: 'Allow',

  permissionsSettingsTaskMove: 'Move task',
  permissionsSettingsTaskMoveOptNo: 'Disallow',
  permissionsSettingsTaskMoveOptBoard: 'Allow only inside board',
  permissionsSettingsTaskMoveOptProject: 'Allow only inside project',
  permissionsSettingsTaskMoveOptYes: 'Allow',
  permissionsSettingsTaskSendMessages: 'Send messages in task chat',
  permissionsSettingsTaskSame: 'Same as all tasks',
  permissionsSettingsTaskSameSpecify: 'Configure',
  permissionsSettingsTaskSameReset: 'Reset to same as all tasks',

  chooseObjectProject: 'Choose project',
  chooseObjectBoard: 'Choose board',
  chooseObjectColumn: 'Choose column',
  chooseObjectTask: 'Choose task',
  permissionsObjectProject: 'Project',
  permissionsObjectBoard: 'Board',
  permissionsObjectColumn: 'Column',
  permissionsObjectTask: 'Task',
  permissionsObjectsEmptyHint<T>(
    normal: (s: string, key: string) => T,
    bold: (s: string, key: string) => T
  ): T[] {
    let ix = 0
    const n = (s: string) => normal(s, '' + ix++)
    const b = (s: string) => bold(s, '' + ix++)
    return [
      n('Add '),
      b('project'),
      n(', '),
      b('board'),
      n(', '),
      b('column'),
      n(' or '),
      b('task'),
      n(' on which you want to provide access to users.')
    ]
  },
  next: 'Next',
  permissionsAddFirstObject: 'Add object to setup its permissions',
  usersAndPermissions: 'Users and Permissions',
  permissionsHintTitle: 'Permissions and access settings',
  permissionsHintText: 'quick video tutorial about permissions',
  permissionsMenuItem: 'User permissions',
  daysLeftNoun: {
    one: 'day',
    other: 'days'
  } as PluralNoun,
  severalDaysSuff: (d: number) => langEn.daysLeftNoun[plural('en', d)],
  daysLeft: (d: number) => d + ' ' + langEn.daysLeftNoun[plural('en', d)],
  newTasksNotification: (n: number) => n + ' new',
  monthsLeftNoun: {
    one: 'month',
    other: 'months'
  } as PluralNoun,
  monthsLeft: (m: number) => m + ' ' + langEn.monthsLeftNoun[plural('en', m)],
  userCountNoun: {
    one: 'user',
    other: 'users'
  } as PluralNoun,
  userCount: (u: number) => u + ' ' + langEn.userCountNoun[plural('en', u)],
  buyLicense: 'Buy license',
  billingMenuItem: 'License and billing',
  billingBannerYouUse: 'You are on ',
  billingBannerVersion: ' version.',
  billingBannerYourTariff: 'Your tariff',
  billingStandardExpiresIn: 'License expires in ',
  billingCurrentTariffPlan: 'Currect tariff plan',
  billingBannerStandardPlan: 'Standard',
  billingBuyStandard: 'Buy license “Standard”',
  billingDuration1: '1 month license',
  billingDuration3: '3 months license',
  billingDuration6: '6 months license',
  billingDuration12: '1 year license',
  billingDuration24: '2 year license',
  billingNumberOfUsers: 'Number of users',
  billingPerUser: 'Per user',
  billingPerMonth: 'Per month',
  billingTotal: 'Total',
  billingYearGift:
    'When paying for a year - pay only for 10 months.' +
    '2 months in a gift, on vacation and time off!',
  billingOpts: 'Payment Options',
  billingCardOpt: 'Pay with card',
  billingInvoiceOpt: 'Invoice',
  billingPayment: 'Payment',
  billingAutoRenew: 'Automatic renewal',
  billingPay: 'Pay',
  billingGetInvoice: 'Get Invoice',
  billingInvoiceSentReq:
    'Request is sent to your manager. We’ll contact you soon.',
  billingPageTitle: 'License and Billing',
  billingBannerStandardDaysLeft: 'Days left',
  billingProlong: 'Renew',
  billingYouGileInfo:
    'YouGile LLC, TIN 7725393915, CRR 772501001, ' +
    '115114, Moscow, Vernadsky Ave., 29, floor 5 room/office 20/b3t, ' +
    'phone. 7 (495) 150-95-70',
  billingHistory: 'Payments history',
  billingActionBuyStandard: (period: string, users: number) =>
    `Buy license for ${period} (${langEn.userCount(users)})`,
  billingActionProplong: (period: string) =>
    `License prolongation for ${period}`,
  billingActionAddUsers: (users: number) =>
    `Adding ${langEn.userCount(users)} to license`,
  billingStandardEnded: 'License ended',
  billingAddUsersTitle: 'Add users to current license',
  billingProlongTitle: 'Prolong license',
  billingLicenseTill: 'License till',
  billingTotalUsers: 'Total users will be',
  userBlocked: 'blocked',
  youBlockedHint:
    'Number of users in this company is not enough ' +
    '(license restriction). Your account has no access to this company. ' +
    'Please contact your administrator.',
  rememberAuth: 'remember',
  boardFiltration: 'Board filtration',
  boardRemoveFilter: 'Remove filtration',
  removeAllBoardFilters: (amount: number) =>
    `Remove ${amount} filter${amount > 1 ? 's' : ''}`,
  statistics: 'Statistics',
  statFilterUser: 'User',
  statFilterDate: 'Date',
  statFilterProject: 'Project',
  statFilterActionType: 'Action Type',
  byUserFilterAssignDate: 'Assign Date',
  userEventAdd: 'Add tasks, columns, etc',
  userEventDelete: 'Remove tasks, columns, etc',
  userEventRestore: 'Restore tasks, columns, etc',
  userEventRename: 'Rename tasks, columns, etc',
  userEventMove: 'Move tasks and columns',
  userEventComplete: 'Archive task',
  userEventUncomplete: 'Unarchive task',
  userEventDone: 'Complete task',
  userEventMessage: 'Write message',
  userEventFile: 'Upload file',
  userEventUsers: 'Adding users',
  userEventsPermissions: 'Permissions editing',

  statActionObjProject: 'project',
  statActionObjBoard: 'board',
  statActionObjColumn: 'column',
  statActionObjTask: 'task',
  statActionObjSticker: 'sticker',

  statActionAddProject: 'Added',
  statActionAddOther: 'Added',
  statActionDeleteProject: 'Deleted',
  statActionDeleteOther: 'Deleted',
  statActionRestoreProject: 'Restored',
  statActionRestoreOther: 'Restored',
  statActionRenameProject: 'Renamed',
  statActionRenameOther: 'Renamed',
  statActionMoveProject: 'Moved',
  statActionMoveOther: 'Moved',

  statActionUncompleteProject: 'Unarchived project',
  statActionUncompleteTask: 'Unarchived task',
  statActionDone: 'Completed task',
  statActionUnDone: 'Uncompleted task',
  statActionMessage: 'Message',
  statActionFile: 'Uploaded file',

  fromTo: (from: string, to: string) => `From “${from}” to “${to}”`,
  onlineTime: 'Online time',
  restore: 'Restore',
  restored: 'restored',
  statsChartTitle: 'Sum of user actions by day',
  statShowChart: 'Show chart',
  startShowLists: 'Show table',
  monthNames: [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ],
  weekNamesShort: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
  taskRename: 'Rename task',
  taskCompleted: 'Task in archive',
  logoutYouGile: 'Change account',
  chatTabChat: 'Chat',
  chatTabDescription: 'Description',
  chatTabSubtasks: 'Subtasks',
  chatTabConnected: 'Linked tasks',
  checklistDefaultName: 'Checklist',
  checklists: 'Checklists',
  subtaskName: 'Subtask Name',
  assigned: 'Assigned',
  systemIsLoading: 'Loading data, please wait...',
  othersTasksPage: 'Tasks by user',
  byUserPageTitle: 'Tasks by user',
  byTimeInColumns: 'Time in columns',
  taskTimesInColumns: 'Task times in columns',
  byUserOpenTasksCount: 'Open tasks',
  byUserNoAssignee: 'No assigned user',
  byUserTimeHint: 'Time since the user was assigned',
  menuArchive: 'Move to archive',
  menuUnarchive: 'Restore from archive',
  menuCopyLink: 'Copy link',
  menuArchiveTasks: 'Archive all tasks',
  menuArchiveCompleted: 'Archive completed',
  sureAchiveAllTasks: 'Archive all tasks shown in this column?',
  sureAchiveCompletedTasks: 'Archive all completed tasks in this column?',
  menuComplete: 'Complete task',
  menuUncomplete: 'Completed',
  myTasksPage: 'My Tasks',
  myTasksNew: 'New',
  myTasksCurrent: 'Current',
  myTasksBacklog: 'Backlog',
  myTasksListName: 'List name',
  myTasksPrivateListName: 'Private list name',
  myTasksDone: 'Done',
  myTasksIncoming: 'Incoming tasks',
  myTasksImportantTasks: 'Important tasks',
  myTasksDefaultPrivateList: 'Private list example',
  myTasksDefaultPrivateTask1: 'Add a private list',
  myTasksDefaultPrivateTask2: 'Create 4 tasks',
  myTasksDefaultPrivateTask3: 'Mark completed tasks',
  myTasksDefaultPrivateTask4: 'Swap private tasks',
  myTasksAddList: 'Add list',
  myTasksAddPrivateList: 'Add a private list',
  myTasksRenameList: 'Rename list',
  myTasksDeleteList: 'Delete list',
  myTasksMoveNew: 'To new',
  myTasksMoveCurrent: 'To current',
  myTasksMoveBacklog: 'To backlog',
  myTasksMoveAllNew: 'All to new',
  myTasksMoveAllCurrent: 'All to current',
  myTasksMoveAllBacklog: 'All to backlog',
  myTasksMoveAllDone: 'Complete all',
  myTasksMoveAllUndone: 'Uncomplete all',
  myTasksMoveAll: 'Move all tasks',
  taskLocation: 'Task location',
  taskStickers: 'Task stickers',
  taskOtherStickers: 'Other stickers',
  noStickers: 'No stickers',
  myTasksAddHint:
    'To add a task to “My tasks” add sticker Assignee to a task in any board',
  actionsByTime: 'Actions by time',
  unseenMyTaskHint: 'User hasn’t viewed the task yet',
  rub: 'rub',
  rub2: 'rub',
  showTaskInfo: 'Show task info',
  sortByDeadline: 'Sort the list by deadline',
  markTaskCompleted: 'Mark task completed',
  taskTemplateNotCompleted: 'Cannot execute subtask in template',
  markTaskUncompleted(timeStr: string): string {
    return `Task was completed at ${timeStr}. Click to uncomplete`
  },
  taskCompletedTimeHint(timeStr: string): string {
    return `Task was completed at ${timeStr}`
  },
  searchResultsHint1: 'Start typing to see search results.',
  searchResultsHint2: 'Hot keys:',
  searchResultsHint3: 'To initiate search — Use Shift-Shift or Command+E.',
  searchResultsHint4:
    'Navigate search results — Utilize the downward arrow ↓ and upward arrow ↑.',
  searchResultsHint5: 'Move from search results to a card/chat — Hit Enter.',
  searchResultsHint6: 'To close the search window: press Escape.',
  searchIndexing: 'Preparing data for search. Not all results are shown.',

  messageEditHint: 'Edit/delete message',
  messageDeleteHint: 'Delete message',
  messageEdited: 'Edited',
  messageEditedHint: (date: string) => `Message was edited ${date}`,
  messagePinHint: 'Create quick link on the message',
  messagePinRemoveHint: 'Remove quick link from the message',
  messagePinEditHint: 'Quick link on the message. Click to edit',
  messageDeleteConfirm: 'Delete this message?',
  moveProjectsHint:
    'You can move projects by dragging with your mouse. Projects order changes only for you, your teammates can choose different order for projects',
  unreadMessages: 'Unread messages',
  toSearchResults: 'Go to search results',
  userListMenuItem: 'Chats with users',
  chatFilterLabel: 'Change list filtration settings',
  backNotifyHint: 'Number of unread messages in all other chats',
  deadlineDescr: 'Drag the sticker to the task to set deadline',
  notAdminConfigureWarn:
    'Only admins are allowed to configure companies. ' +
    'Open company where you are admin to configure it',
  createGroupChat: 'Create group chat',
  editGroupChat: 'Edit group chat name and participants',
  groupChat: 'Group chat',
  groupChatMute: 'Turn off notifications for this chat',
  groupChatUnmute: 'Turn on notifications for this chat',
  groupChatSettings: 'Group chat settings',
  groupChatTitlePlaceholder: 'Enter chat title',
  groupChatParticipants: 'List of participants',
  groupChatNew: 'New group chat',
  groupChatNoUsersOnCreate: 'Please choose at least one participant',
  groupChatNoUsersOnEdit: 'Delete this chat?',
  groupChatNoUsersOnEditHint:
    'You deleted all users from the group chat, it will not be available to anyone and will be deleted',
  subscribedToTask: 'Chat participants',
  chatSubscribe: 'Subscribe',
  chatUnsubscribe: 'Unsubscribe',
  chatSubscribeAll: 'Select everybody',
  chatUnsubscribeAll: 'nobody',
  chatSubscribeReverse: 'reverse',
  chatSubscribeSearch: 'Search in the list',
  feedbackChatDescription:
    'This is a chat with YouGile support. It is visible only to you and the staff of YouGile',
  reportsTitle: 'Reports',
  fieldIdTask: 'ID Task',
  fieldTitle: 'Task title',
  fieldDescription: 'Task description',
  fieldChecklist: 'Checklists',
  fieldCreatedAt: 'Created at',
  fieldCreatedBy: 'Author',
  fieldAssignedTo: 'Assigned to',
  fieldResponsible: 'Responsible',
  fieldAssignedAt: 'Assigned at',
  fieldCompletedAt: 'Completed at',
  fieldDeadline: 'Deadline',
  fieldProject: 'Project',
  fieldBoard: 'Board',
  fieldColumn: 'Column',
  fieldLastMove: 'Moved at',
  fieldlastMessage: 'Last message time',
  fieldMessagesCount: 'Messages count',
  statsReport: 'Report',
  statsAddReport: 'Add new report',
  statsAddColumnReport: 'Add new dashboard',
  statsEditReport: 'Edit report',
  statsEditColumnReport: 'Edit dashboard',
  statsDownloadXlsx: 'Download report',
  statsReportName: 'Report name',
  statsColumnReportName: 'Dashboard name',
  statsDeleteReport: 'Delete report',
  statsDeleteColumnReport: 'Delete dashboard',
  statsSort: 'Sorting',
  statsFilter: 'Filter',
  statsFilterAny: 'Any',
  statsFilterAnyProject: 'Any project',
  statsFilterAnyBoard: 'All boards',
  statsFilterWithoutBoard: 'Without board',
  statsFilterAnyColumn: 'All columns',
  statsFilterCreatedBy: 'Created by',
  statsFilterCreatedAt: 'Creation date',
  statsFilterAssignedTo: 'Assigned to',
  statsFilterAssignedBy: 'Assigned by',
  statsFilterResponsible: 'Responsible',
  statsFilterMoveDate: 'Moved at',
  statsFilterLastMessage: 'Last message date',
  statsFilterDeadline: 'Deadline',
  statsFilterStickers: 'Text stickers',
  statsFilterDate1d: 'Today',
  statsFilter7d: 'Last 7 days',
  statsFilter30d: 'Last 30 days',
  statsFilterNext7d: 'Next 7 days',
  statsFilterNext30d: 'Next 30 days',
  statsFilterCurrentWeek: 'Current week',
  statsFilterCurrentMonth: 'Current month',
  statsFilterPrevWeek: 'Previous week',
  statsFilterPrevMonth: 'Previous month',
  statsFilterNextWeek: 'Next week',
  statsFilterNextMonth: 'Next month',
  statsNotSet: 'Not assigned',
  statsUserNotSet: 'Not assigned',
  statsNotPinned: 'Not pinned',
  statsTasksFound: 'Total tasks',
  statsPage: 'Page',
  statsPrev: 'Previous',
  statsNext: 'Next',
  totalValueByColumn: 'Total value by column',
  sumOfValues: 'Sum of values',
  statFilterCompleteness: 'Completeness state',
  statsCompleteAny: 'Any',
  statsCompleteCompleted: 'Completed',
  statsCompleteNotCompleted: 'Not completed',
  statCompletedAt: 'Completion date',
  statFilterArchiveness: 'Archivation state',
  statArchivenessNo: 'Not in archive',
  statArchivenessYes: 'In archive',
  statArchivenessAny: 'Any',
  statSticker: 'Sticker',
  statAddSticker: 'Add sticker',
  statChooseSticker: 'Choose sticker',
  statChooseState: 'Choose sticker state',
  statStateIncludeHint: 'This state is included. Click to exclude it',
  statStateExcludeHint: 'This state is excludes. Click to include it',
  statsTimetrackingSet: 'Is set',
  statsTimetrackingNotSet: 'Isn’t set',
  statsTimetrackingExceedsPlan: 'Exceeds plan',
  statsTimetrackingNotExceedsPlan: 'Not exceeds plan',
  statsDeleteReportConfirm: 'Delete report?',
  specifyValue: 'Specify value',
  specifyStickerValueForThatSticker: 'Specify the sticker value for this task',
  boardCreateDashboard: 'Create dashboard',
  dashboard: 'Dashboard',
  downloadDashboardXlsx: 'Download dashboard as *.xlsx file',
  dashboardSettings: 'Dashboard settings',
  boardDeleteReportConfirm: 'Delete dashboard?',
  result: 'Result',
  reportNoDragTask:
    'The tasks in dashboard columns are not draggable. Use usual column or mirror column instead.',
  asc: 'Ascending',
  desc: 'Descending',
  statsAddFilter: 'Add filter',
  statsChooseFilter: 'Choose filter',
  statsAddSort: 'Add sorting',
  statsChooseSort: 'Choose sorting',
  statsIncluded: 'Included',
  statsExcluded: 'Excluded',
  statsAddLocation: 'Add location',
  noProjectsHint:
    'You are not added to any project, please contact this company administrator',
  datePickerFrom: 'From',
  datePickerTill: 'till',
  datePickerBlockedRangeStart:
    'Cannot change start date of the task because it depends on another task',
  addTaskStickerErrorMessage:
    'It is necessary to put down the values of the selected stickers',
  addTaskEmptyTextErrorMessage: 'Task name is required',
  changesHistory: 'History of changes',
  changesHistoryHint: 'You can copy text from here',
  changesHistorySubmit: 'Restore this version',
  historyIsEmpty: 'Version history is empty',
  historyIsEmptyHint:
    'After the description has been changed the versions will be displayed here.',
  descriptionIsEmpty: "Now it's empty",
  descriptionIsEmptyHint: 'Click "Edit Description" to add text.',
  userIsNotFound: 'User is not found',
  setTaskImage: 'Set as cover',
  setChatImage: 'Set as cover of the chat',
  removeTaskImage: 'Remove cover',
  removeCurrentTaskImage: 'Remove current cover',
  uploadTaskImage: 'Upload cover...',
  datePlaceholder: 'DD.MM.YYYY',
  emptySearchResults: 'Nothing found',

  alreadyConnected: 'The task already connected',

  errorUserAccountIsReadonly: 'User account is read-only',
  errorUserIdIsNotValid: 'User id is not valid',
  errorEmailIsNotValid: 'Email is not valid',
  errorUserNotFound: 'User not found',
  errorCompanyNotFound: 'Company not found',
  errorIncorrectPassword: 'Incorrect password',
  errorIncorrectToken: 'Incorrect token',
  errorExpiredToken: 'Token is expired',
  errorUnknown: 'Unknown error',
  errorEmailAddressAlreadyInUse: 'Email address already in use',
  errorForbiddenByCompanyPermissions: (companyName: string): string =>
    `This action is forbidden by company "${companyName}" permission`,
  errorNotSaveData: 'Attention! Unsaved Data!',
  googleCalendarIntegration: 'Integrating tasks into Google Calendar',
  chooseGoogleAccount: 'Select Google account',
  chooseCalendar: 'Choose calendar',
  chooseBoardProject: 'Select boards/projects',
  voiceMessageTitle: '🎤 Voice message',
  undefined: 'Undefined',

  showSystemMessages: 'Show system messages',
  hideSystemMessages: 'Hide read system messages',

  nothingInClipboard: 'There is no data in clipboard',
  noLinkInClipboard: 'No task link in clipboard: ',
  noTaskByHashInClipboard: 'No task by hash in clipboard: ',
  noPermissionToRenameInTargetColumnMoveCancelled:
    'You do not have permission to rename this task in the target column. Movement cancelled.',
  noPermissionToEditStopwatchOnComplete:
    'You do not have permission to change stopwatch state.',
  errorOnlyDigitsAllowed: 'Only digits allowed',
  errorInvalidEmail: 'Invalid email address',
  errorInvalidURL: 'Invalid URL',
  empty: 'Empty',
  noMessages: 'No messages'
}
